import { Checkbox } from "@mui/material";
import { useState } from "react";

const ControlledCheckbox = ({ handleChange, setCheck, checked = false }) => {
  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
};

export default ControlledCheckbox;
